import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'upload-file-float-bar',
  templateUrl: './upload-file-float-bar.component.html',
  styleUrl: './upload-file-float-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFileFloatBarComponent {
  @Input() selectedItemsArray: any[] = [];
  @Output() actionEvent = new EventEmitter<any>();
  clearSelection() {
    this.actionEvent.emit({
      action: 'clearSelection',
    });
  }
  deleteSelection() {
    this.actionEvent.emit({
      action: 'deleteSelection',
    });
  }
  saveSelection() {
    this.actionEvent.emit({
      action: 'saveSelection',
    });
  }
}
